export enum UserEditMessages {
  PageTitle = 'Edit user',
}
